import React from 'react';
import PropTypes from 'prop-types';

import '../styles/CameraButtons.css';

export const RoundButton = ({label, eventHandler, buttonText}) => {

    /* if button has functionality we render it on desktop and mobile(!) */
    const wrapperClass = eventHandler ? "Button-round-wrapper" : "Button-round-wrapper for-desktop-only";
    const buttonElement = eventHandler 
        ? <button className="Button-round" onClick={eventHandler}></button>
        : <button className="Button-round">{buttonText}</button>
    return (
        <div className={wrapperClass}>
            <label>{label}</label>
            <div className="Button-round-outter">
                {buttonElement}
            </div>
        </div>
    )
}

RoundButton.propTypes = {
    label: PropTypes.string,
    eventHandler: PropTypes.func,
    buttonText: PropTypes.string,
}

export const NavigationButton = ({direction, eventHandler}) => (
    <button className={`Button-navigation Button-${direction}`} onMouseDown={eventHandler}>
        <div className={`Button-navigation-inner Button-${direction}-inner`}></div>
    </button>
);

NavigationButton.propTypes = {
    direction: PropTypes.string,
    eventHandler: PropTypes.func,
}

export const OkButton = ({eventHandler}) => (
    <div className="Button-ok-outer">
        <button className="Button-ok" onClick={eventHandler}>
            <div className="Button-ok-inner"></div>
        </button>
    </div>
);

OkButton.propTypes = {
    eventHandler: PropTypes.func,
}



